import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

const CompanyContext = createContext({});

export function CompanyProvider({ children }) {
  const [company, setCompany] = useState({
    company_name: '',
    company_address: '',
    company_city: '',
    company_state: '',
    company_zip: '',
    company_country: '',
    company_phone: '',
    company_email: '',
    company_website: '',
  });

  useEffect(() => {
    axios.get(`${API}/settings/company/public`)
      .then(res => setCompany(res.data))
      .catch(() => {});
  }, []);

  return (
    <CompanyContext.Provider value={company}>
      {children}
    </CompanyContext.Provider>
  );
}

export function useCompany() {
  return useContext(CompanyContext);
}
